import {Injectable} from '@angular/core';
import {UiBlockService} from "../ui-block.service";
import {FeatureType} from "../../models/EnumTypes";
import {PointsService} from "../points.service";
import {ModalControlService} from "../modal-control.service";
import {ModalConfirmationService} from "../modal-confirmation.service";
import {GritApiService} from "./grit.api.service";
import {GritCoordinates, GritCoordinateType} from "../../models/grit/grit.coordinates";
import {InterferenceTestModel} from "../../models/grit/grit.interference-test-model";
import {RadarModel} from "../../models/grit/grit.radar-model";
import {FilterMode, FilterTab} from "./grit.feature-filter.service";
import {GritFilter} from "../../models/grit/grit.filter";
import {GritFeature} from "../../models/grit/grit.feature";
import {UserSettingsService} from "../userSettings.service";
import {GritDynamicTableMode} from "../../models/grit/grit.enums";

@Injectable({
  providedIn: 'root'
})
export class GritRadarService {

  public detailsTab = {
    active : false,
    edit: false,
    selected : new RadarModel(),
  }

  public filterTab : FilterTab = new FilterTab(
    FeatureType.Radar,
    RadarModel.configuration.filters,
    (filters: GritFilter[]) => {
      this.userSettingsService.userSettings.radarsSettings.filters = filters;
      this.userSettingsService.updateSettings();
      return true;
    },
    () => {
      this.pointsService.clearGritFeaturesFromLayer(FeatureType.Radar);
      this.pointsService.fetchAndAddRadars();
    },
    (feature: GritFeature<InterferenceTestModel>, mode : FilterMode, result: boolean) => {
      return false;
    })

  constructor(
    private modalService : ModalControlService,
    private modalConfirmation: ModalConfirmationService,
    private uiBlock: UiBlockService,
    private gritAPIService: GritApiService,
    private pointsService: PointsService,
    private userSettingsService: UserSettingsService
  ){
  }

  toggleDetails(active: boolean, radar: RadarModel = null){
    this.detailsTab.active = active;
    if (!active) return;

    this.detailsTab.selected = new RadarModel();

    if (radar !== null){
      let latitude = new GritCoordinates(GritCoordinateType.Latitude);
      let longitude = new GritCoordinates(GritCoordinateType.Longitude);
      this.detailsTab.selected = Object.assign(this.detailsTab.selected, radar);
      this.detailsTab.selected.latitude = Object.assign(latitude, radar.latitude);
      this.detailsTab.selected.longitude = Object.assign(longitude, radar.longitude);
    }

    //TODO FIXME
    // this.detailsTab.edit = this.detailsTab.selected.userId == null || this.detailsTab.selected.userId == "gmv";
  }

  async deleteRadar(){
    let features = await this.pointsService.getGritSelected<RadarModel>(FeatureType.Radar, GritDynamicTableMode.SELECT_MULTIPLE);

    if (features != null){
      this.modalConfirmation.showMesssageConfirmationModal(
        "Delete Radars",
        "Do you want to delete the selected radars?",
        "Yes", "No",
        () =>   {
          this.uiBlock.startBlock("Deleting radars...")

          return this.gritAPIService.radarDelete(features.map(feature => feature.entity)).then(
            (radars) => {
              this.pointsService.removeGritFeaturesFromMap(features)
              this.modalService.showMesssageModal("Radars Delete", "Radars deleted with success.");
            },
            (error) => this.modalService.showMesssageModal("Radars Delete", "Error deleting the selected radars.")
          ).finally(() => this.uiBlock.stopBlock());
        });
    }
  }

  activateProject(publicProject: boolean){
    this.filterTab.addedFilters = this.userSettingsService.userSettings.radarsSettings.filters.map(filter => new GritFilter().fromDto(filter))
  }
}
